import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import MobileModal from "./MobileModal";
import { MobileModalHeader } from "./MobileModalHeader";
import { MobileModalBody } from "./MobileModalBody";
import { useUpdateItem } from "../../../_helper/actions/mutation/items";
import InputField from "../../../common_component/component/InputField";
import CuDropdown from "../../../common_component/component/CuDropdown";
import CustomButton from "../../../common_component/component/CustomButton";
import CuModal from "../../../common_component/component/CuModal";
import { DateToyyyymmdd } from "../../../_helper/utils/utils";
import {
  clinicAtom,
  doctorListAtom,
  selectedDoctorAtom,
} from "../../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { toast } from "react-toastify";
import CuForm from "../../../common_component/component/CuForm";
import { dateConvertToPayloadBookingFormat } from "../../../components/admin/setup/helper/Helper";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { WEBSOCKET_URL } from "../../../_helper/constant/constant";
import { IoClose } from "react-icons/io5";

const durationOptions = [
  { key: 1, value: 5, text: "5 min" },
  { key: 2, value: 7, text: "7 min" },
  { key: 3, value: 10, text: "10 min" },
  { key: 4, value: 15, text: "15 min" },
  { key: 5, value: 20, text: "20 min" },
];

const utctoseconds = (utct, iswalkin = false) => {
  var d = new Date(iswalkin ? utct : utct + "Z");
  var h = d.getHours();
  var m = d.getMinutes();
  var s = d.getSeconds();
  return h * 3600 + m * 60 + s;
};

const checkBookedSlotData = (
  slot_start_time,
  slot_end_time,
  booked_slots,
  date
) => {
  var isbooked = false;
  for (var i = 0; i < booked_slots?.length; i++) {
    let [dt, tm] = booked_slots[i]?.start_time.split("T");
    let [dt1, tm1] = booked_slots[i]?.end_time.split("T");
    const booked_slots_start_time = utctoseconds(booked_slots[i].start_time);
    const booked_slots_end_time = utctoseconds(booked_slots[i].end_time);

    if (
      Date(dt) === Date(DateToyyyymmdd(date)) &&
      Date(dt1) === Date(DateToyyyymmdd(date))
    ) {
      if (
        (slot_start_time >= booked_slots_start_time &&
          slot_end_time <= booked_slots_end_time) ||
        (slot_start_time < booked_slots_start_time &&
          slot_end_time > booked_slots_start_time) ||
        (slot_start_time < booked_slots_end_time &&
          slot_end_time > booked_slots_end_time)
      ) {
        isbooked = booked_slots[i];
        break;
      } else {
        isbooked = false;
      }
    } else {
      isbooked = false;
    }
  }
  return isbooked;
};

const RescheduleAppointment = ({ isReschedule, setIsReschedule, role_id }) => {
  const [doctorList] = useAtom(doctorListAtom);
  const [doctorListOptions, setDoctorListOptions] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useAtom(selectedDoctorAtom);
  const sm = !useMediaQuery({ query: "(min-width:1024px)" });
  const [formData, setFormData] = useState({
    slotId: null,
    date: "",
    startTime: "",
    duration: "5 min",
  });
  const [getSlotTime, setGetSlotTime] = useState({
    start_time: "2023-10-28T00:00:00",
    end_time: "2023-10-28T03:40:00",
  });

  const [isSMS, setIsSMS] = useState(true);

  const update_mutation = useUpdateItem(ApiEndPoint?.QM_SC_SLOTS);

  const [clinic] = useAtom(clinicAtom);

  useEffect(() => {
    if (formData?.date) {
      const dateParts = formData?.date.split("-");
      if (dateParts && dateParts?.length === 3) {
        const [year, month, day] = dateParts;
        let start_time, end_time;
        const [sh, sm] = formData?.startTime?.split(":") || [0, 0];

        start_time = new Date(
          year,
          month - 1,
          day,
          parseInt(sh),
          parseInt(sm),
          0,
          0
        ).toISOString();

        const custom_end_time = new Date(
          new Date(start_time).getTime() + 30 * 60 * 1000
        ).toISOString();

        const timestamp1 = start_time;
        const timestamp2 = custom_end_time;

        const trimmedTimestamp1 = timestamp1.replace(/\.000Z$/, "");
        const trimmedTimestamp2 = timestamp2.replace(/\.000Z$/, "");

        setGetSlotTime({
          start_time: trimmedTimestamp1,
          end_time: trimmedTimestamp2,
        });
      } else {
      }
    }
  }, [formData]);

  useEffect(() => {
    if (isReschedule?.flag && isReschedule?.data) {
      setFormData(isReschedule?.data);
    }
  }, [isReschedule]);

  useEffect(() => {
    const mapDoctorOptions = doctorList.map((item) => ({
      key: item.id,
      value: item.id,
      text: `${item.first_name} ${item.last_name}`,
    }));
    setDoctorListOptions(mapDoctorOptions);
    // if (doctorList.length > 0 && !selectedDoctor) {
    //   setSelectedDoctor(doctorList[0].id);
    // }
  }, []);

  const closeModal = () => {
    setIsReschedule({ data: null, flag: false });
    setFormData({
      slotId: null,
      date: "",
      startTime: "",
      duration: "5 min",
    });
  };

  const handleChange = (val, label) => {
    setFormData((prev) => ({ ...prev, [label]: val }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let y, m, d, ey, emo, ed;
    [y, m, d] = formData?.date?.split("-");
    const [sh, sm] = formData?.startTime?.split(":") || [0, 0];

    const start_time = new Date(
      y,
      m - 1,
      d,
      parseInt(sh),
      parseInt(sm),
      0,
      0
    ).toISOString();

    const end_time = new Date(
      new Date(start_time).getTime() + formData?.duration * 60 * 1000
    ).toISOString();
    // const duration = formData?.duration * 60;

    const duration = formData?.duration;

    const payload = {
      id: formData?.slotId,
      action: "patchSlots",
      frontend: "True",
      clinic_id: clinic?.id,
      notification: isSMS,
      start_time: dateConvertToPayloadBookingFormat(start_time),
      end_time: dateConvertToPayloadBookingFormat(end_time),
      duration,
      doctor_user: selectedDoctor,
    };

    update_mutation.mutate(
      { data: payload },
      {
        onSuccess: () => {
          toast.success("Rescheduled");
          closeModal();
        },
        onError: () => {
          toast.error("Failed to reschedule");
        },
      }
    );
  };

  const space = {
    marginBottom: "0px",
  };

  const handleSelectDoctor = (value) => {
    setSelectedDoctor(value);
  };
  //("value4---------", selectedDoctor);

  return (
    <>
      {sm ? (
        <MobileModal
          isOpen={isReschedule?.flag}
          closeModal={closeModal}
          modalClassName="modal-container-reschedule-appointment"
          event={"hey"}
        >
          <MobileModalHeader>
            <h4 style={{ margin: "10px auto 5px" }}>
              Reschedule the Appointment
            </h4>
          </MobileModalHeader>
          <MobileModalBody>
            <CuForm onSubmit={handleSubmit}>
              {doctorList?.length > 0 && doctorListOptions?.length > 0 && (
                <div className="bookslot-firstrow p-2">
                  <label>Select Doctor</label>
                  <CuDropdown
                    placeholder={"Select Doctor"}
                    options={doctorListOptions}
                    value={selectedDoctor}
                    onChange={handleSelectDoctor}
                  />
                </div>
              )}
              <div style={space} className="bookslot-firstrow p-2">
                <InputField
                  label={"Date"}
                  type={"date"}
                  value={formData?.date}
                  required
                  onChange={(e) => handleChange(e.target.value, "date")}
                />
              </div>
              <div style={space} className="bookslot-firstrow p-2">
                <InputField
                  label={"Start Time"}
                  type={"time"}
                  value={formData?.startTime}
                  required
                  onChange={(e) => handleChange(e.target.value, "startTime")}
                />
              </div>
              <div style={space} className="bookslot-firstrow p-2">
                <label className="lg:text-sm xl:text-base xlarge:text-xl">
                  Duration
                </label>
                <CuDropdown
                  options={durationOptions}
                  value={formData?.duration}
                  onChange={(val) => handleChange(val, "duration")}
                  required
                />
              </div>
              <div
                className="mb-2 mt-3"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="checkbox"
                  checked={isSMS}
                  onChange={() => setIsSMS((prev) => !prev)}
                />
                <label
                  className="lg:text-base xl:text-lg xlarge:text-xl"
                  style={{ marginBottom: "0px" }}
                >
                  Send Notification
                </label>
              </div>
              <div className="btn-center mt-4">
                <CustomButton
                  color={"rgba(199, 234, 201, 1)"}
                  textColor={"rgba(0, 0, 0, 1)"}
                  className="btn-mobile w-[90%] lg:h-11 xl:h-12"
                  // style={{ width: "90%", height: "48px" }}
                  type="submit"
                  loading={update_mutation.isLoading}
                >
                  <span className="lg:text-base xl:text-lg xlarge:text-xl">
                    {" "}
                    Reschedule
                  </span>
                </CustomButton>
              </div>
            </CuForm>
          </MobileModalBody>
        </MobileModal>
      ) : (
        <>
          <CuModal closeModal={closeModal}>
            <CuForm onSubmit={handleSubmit}>
              <div className="flex justify-between px-3">
                <h3 className="font-normal lg:text-lg xl:text-xl xlarge:text-2xl">
                  Reschedule appointment
                </h3>
                <IoClose
                  size={23}
                  onClick={closeModal}
                  className="cursor-pointer"
                />
              </div>
              <div className="bookslot-firstrow p-3">
                {doctorList?.length > 0 && doctorListOptions?.length > 0 && (
                  <div className="mb-4">
                    <label>Select Doctor</label>
                    <CuDropdown
                      placeholder={"Select Doctor"}
                      options={doctorListOptions}
                      value={selectedDoctor}
                      onChange={handleSelectDoctor}
                    />
                  </div>
                )}
                <InputField
                  label={"Date"}
                  type={"date"}
                  value={formData?.date}
                  required
                  onChange={(e) => handleChange(e.target.value, "date")}
                />
              </div>
              <div className="bookslot-firstrow p-3">
                <InputField
                  label={"Start Time"}
                  type={"time"}
                  value={formData?.startTime}
                  required
                  onChange={(e) => handleChange(e.target.value, "startTime")}
                />
              </div>
              <div className="bookslot-firstrow p-3">
                <label className="lg:text-sm xl:text-base xlarge:text-xl">
                  Duration
                </label>
                <CuDropdown
                  options={durationOptions}
                  value={formData?.duration}
                  onChange={(val) => handleChange(val, "duration")}
                  required
                />
              </div>
              <div className="btn-center mt-4">
                <CustomButton
                  color={"rgba(199, 234, 201, 1)"}
                  textColor={"rgba(0, 0, 0, 1)"}
                  className="btn-mobile w-[90%] lg:h-11 xl:h-12"
                  type="submit"
                  loading={update_mutation.isLoading}
                >
                  <span className="lg:text-base xl:text-lg xlarge:text-xl">
                    {" "}
                    Reschedule
                  </span>
                </CustomButton>
              </div>
              <div
                className="mb-2 mt-3"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <input
                  type="checkbox"
                  checked={isSMS}
                  onChange={() => setIsSMS((prev) => !prev)}
                />
                <label
                  className="lg:text-base xl:text-lg xlarge:text-xl"
                  style={{ marginBottom: "0px" }}
                >
                  Send Notification
                </label>
              </div>
            </CuForm>
          </CuModal>
        </>
      )}
    </>
  );
};

export default RescheduleAppointment;
